import { createSlice } from '@reduxjs/toolkit';
import { requestRiskCalculation, getRiskStatus, getLatestRisks } from './risks-operations';
import { RisksState } from './RisksTypes';

const initialState: RisksState = {
  latest: null,
  current: null,

  loading: false,
  polling: false,
  error: null,
};

const risksSlice = createSlice({
  name: 'risks',
  initialState,
  reducers: {
    resetRisks: () => initialState,
    invalidateLatestRisks: (state) => {
      state.latest = null;
      state.error = null;
    },
  },
  extraReducers: builder => {
    /* -------- запрос latest -------- */
    builder.addCase(getLatestRisks.pending, state => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getLatestRisks.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.polling = false;
      state.error = null;
      state.latest = payload;
    });
    builder.addCase(getLatestRisks.rejected, (state, { payload, error }) => {
      if (payload?.status === 409) {
        state.loading = false;
        state.polling = true;
        state.error = null;
        return;
      }
      state.loading = false;
      state.error = payload?.message || error.message || null;
    });

    /* -------- POST /risks-requests -------- */
    builder.addCase(requestRiskCalculation.pending, state => {
      state.polling = true;
      state.error = null;
    });
    builder.addCase(requestRiskCalculation.fulfilled, (state, { payload }) => {
      state.current = payload; // pending объект
    });
    builder.addCase(requestRiskCalculation.rejected, (state, { payload, error }) => {
      state.polling = false;
      state.error = payload?.message || error.message || null;
    });

    /* -------- GET /risks-requests/{id} -------- */
    builder.addCase(getRiskStatus.fulfilled, (state, { payload }) => {
      state.current = payload;
      if (payload.status === 'completed') {
        state.latest = payload;
        state.polling = false;
      }
      if (payload.status === 'failed') {
        state.polling = false;
        state.error = payload.error || 'Risk calculation failed';
      }
    });
    builder.addCase(getRiskStatus.rejected, (state, { payload, error }) => {
      state.polling = false;
      state.error = payload?.message || error.message || null;
    });
  },
});

export const { resetRisks, invalidateLatestRisks } = risksSlice.actions;
export default risksSlice.reducer;
